import config from '../config'
import {
  CorporateOnlyLessonDefinition,
  CreateCorporateOnlyLessonDefinitionParams,
  IPaginatedCorporateOnlyLessonDefinitionFilterParams,
  PaginatedCorporateOnlyLessonDefinition,
} from '../pages/corporate-only-lesson-definitions-container/share-type'
import { authRequest } from '../request'

const { mainApi } = config

export const getPaginatedCorporateOnlyLessonDefinitions = (
  data: IPaginatedCorporateOnlyLessonDefinitionFilterParams,
) =>
  authRequest.get<MISSING_TYPE, PaginatedCorporateOnlyLessonDefinition>(
    `${mainApi}/corporate-only-lesson-definitions`,
    {
      params: data,
    },
  )

export const createCorporateOnlyLessonDefinition = (
  data: CreateCorporateOnlyLessonDefinitionParams,
): Promise<CorporateOnlyLessonDefinition> =>
  authRequest.post(`${mainApi}/corporate-only-lesson-definitions`, data)

export const getCorporateOnlyLessonDefinitionDetail = (corporateOnlyLessonDefinitionId: number) =>
  authRequest.get(`${mainApi}/corporate-only-lesson-definitions/${corporateOnlyLessonDefinitionId}`)

export const editCorporateOnlyLessonDefinitionDetail = (
  corporateOnlyLessonDefinitionId: number,
  data: CreateCorporateOnlyLessonDefinitionParams,
): Promise<CorporateOnlyLessonDefinition> =>
  authRequest.put(
    `${mainApi}/corporate-only-lesson-definitions/${corporateOnlyLessonDefinitionId}`,
    data,
  )

export const deleteCorporateOnlyLessonDefinition = (corporateOnlyLessonDefinitionId: number) =>
  authRequest.delete(
    `${mainApi}/corporate-only-lesson-definitions/${corporateOnlyLessonDefinitionId}`,
  )
